import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/ether/problem_back.webp";

function Problemether() {
  return (
    <section
      className="problemether text_white p-100"
      style={{ backgroundImage: `url(${BgImg})`, backgroundColor: "#141826" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>The Problem</h2>
            <p>
              Elementeum Games already had an existing a block-chain based
              mobile game incrementally developed since 2019 on (Android & iOS)
              in which players were potentially able to:
            </p>
            <ul>
              <li> Play to earn NFT’s, and various tokens</li>
              <li>
                Continue gaming ambitions without the need or involve
                contemporary cash at all
              </li>
              <li>
                Link to Ethereum, Polygon and other blockchain wallets for
                seamless NFT connectivity, use-case and digital content
                ownership contemporary cash at all
              </li>
              <li>
                Choose character NFT’s for PVP battle with leaderboard concepts
              </li>
            </ul>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1"
          >
            <p>
              However, the game had various functional issues due to poor
              development and programming practices followed by the previous
              development firm, and that’s when the client approached TekRevol
              to help with stabilizing as well as further scaling the game.
            </p>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="problem_ether_img">
              <StaticImage
                src="../../../images/case-studies/ether/problem_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1404}
                height={611}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problemether;
